import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ApiTokenDto } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { DeleteUserDialogComponent } from '../../user-management/delete-user-dialog/delete-user-dialog.component';
import { DeleteApitokenDialogComponent } from '../delete-apitoken-dialog/delete-apitoken-dialog.component';

@Component({
    selector: 'app-apitokens-button-renderer',
    templateUrl: './apitokens-button-renderer.component.html',
    styleUrls: ['./apitokens-button-renderer.component.scss'],
    standalone: false
})
export class ApitokensButtonRendererComponent implements ICellRendererAngularComp {

    params: any;
  
    icon_delete!:string;  
  
    // routerLinkEditUser!:string;
    // routerLinkViewUser!:string;
  
    constructor(
      public dialog: MatDialog,    
      // private accountService:AccountService,
      private oauthService: OAuthServiceService,
      private tenantService:TenantService,
      public translate: TranslateService,
      private notificationService: NotificationService
    ) { }
  
    refresh(params: ICellRendererParams): boolean {
      const dataParams = params.colDef?.cellRendererParams;
      // this.routerLinkViewUser = _.isFunction(dataParams.routerLinkViewUser) ? dataParams.routerLinkViewUser(params) : _.get(params.data, dataParams.routerLinkViewUser);
      // this.routerLinkEditUser = _.isFunction(dataParams.routerLinkEditUser) ? dataParams.routerLinkEditUser(params) : _.get(params.data, dataParams.routerLinkEditUser);
      return false;
    }
  
    agInit(params: ICellRendererParams): void {
      this.params = params;
      //console.log("=======================> RendererParams Button = ", params);
  
      this.icon_delete = this.params.icon_delete || null;
     
      // this.routerLinkViewUser = this.params.routerLinkViewUser || null;
      // this.routerLinkEditUser = this.params.routerLinkEditUser || null;
  
      // this.oauthService.userData.subscribe({
      //   next: (data) => {
      //     if (typeof data != undefined && data != null) {
      //       let userRoles = (data as any).role as Array<string>;
      //       userRoles.forEach((dbrole: string) => {
      //         if (dbrole === 'admin') {
      //           // this._db = dbrole;
      //          }
      //       });
      //     }
      //   }
      // });
      this.refresh(params);
    }
  
    deleteApiToken() {
      const rowData = [this.params.node.data];
      
      let userDto = new ApiTokenDto;
  
      userDto.id = rowData[0].id;
      userDto.user_Name = rowData[0].user_Name;

      console.log("delete Api Token rowData = ", rowData)
      console.log("delete Api Token userDto = ", userDto)
      // userDto.email = rowData[0].email;
      // userDto.emailConfirmed = rowData[0].emailConfirmed;
      // userDto.first_Name = rowData[0].firstName;
      // userDto.last_Name = rowData[0].lastName;
      // userDto.phoneNumber = rowData[0].phoneNumber;
      // userDto.phoneNumberConfirmed = rowData[0].phoneNumberConfirmed;
      // userDto.twoFactorEnabled = rowData[0].twoFactorEnabled;
      // userDto.lockoutEnabled = rowData[0].lockoutEnabled;
      // userDto.lockoutEnd = rowData[0].lockoutEnd;
      // userDto.accessFailedCount = rowData[0].accessFailedCount;
      // userDto.userRoles = rowData[0].userRoles;
  

      // const dialogRef = this.dialog.open(DeleteApiTokenDialogComponent, {width: '500px',data:{userDto: userDto, params: this.params} }); 
      const dialogRef = this.dialog.open(DeleteApitokenDialogComponent, {width: '800px',data:{userDto: rowData[0], params: this.params} }); 
      dialogRef.afterClosed().subscribe((result:any) => {
  
        if(result != undefined){
          
            let db:string = this.tenantService.currentTenantName;
  
            this.tenantService.deleteApiToken(db, result.id).subscribe({
              next: (success) => {
                this.params.api.refreshInfiniteCache();
                this.notificationService.success("", "Api Token wurde gelöscht");
              },
              error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler beim Löschen des Tokens")
            });
         
        } // else Abbruch
      });    
    }
  
}
